export const GET_SURVEY_LOADING = "GET_SURVEY_LOADING";
export const GET_SURVEY_SUCCESS = "GET_SURVEY_SUCCESS";
export const GET_SURVEY_FAILURE = "GET_SURVEY_FAILURE";

export const SURVEY_CONFIRM_LOADING = "SURVEY_CONFIRM_LOADING";
export const SURVEY_CONFIRM_SUCCESS = "SURVEY_CONFIRM_SUCCESS";
export const SURVEY_CONFIRM_FAILURE = "SURVEY_CONFIRM_FAILURE";
export const SURVEY_CONFIRM_RESET = "SURVEY_CONFIRM_RESET";

export const SURVEY_FORM_LOADING = "SURVEY_FORM_LOADING";
export const SURVEY_FORM_SUCCESS = "SURVEY_FORM_SUCCESS";
export const SURVEY_FORM_FAILURE = "SURVEY_FORM_FAILURE";
export const SURVEY_FORM_RESET = "SURVEY_FORM_RESET";

export const DELETE_SURVEY = "DELETE_SURVEY";
